import { camelizeKeys } from 'humps';
import {PRODUCT_CATEGORIES} from "../constants";

export default {
  createOrder(portal, purchaseFlow, shippingInformation, paymentInformation, lineItems, promoCode, clientTotalPrice, referralCode, giftSenderInformation, adminReferralTargetCode, npi, deferredUserCreate) {
    const planLineItem = lineItems.find(li => li.product.category === PRODUCT_CATEGORIES.MEMBERSHIP);
    const selectedPlan = planLineItem ? planLineItem.product : null;

    const order = {
      customer: {
        first_name: shippingInformation.firstName,
        last_name: shippingInformation.lastName,
        email: shippingInformation.email,
        address1: shippingInformation.address1,
        address2: shippingInformation.address2,
        phone: shippingInformation.phone,
        city: shippingInformation.city,
        state: shippingInformation.state,
        country_code: shippingInformation.country.code,

        using_billing_address: paymentInformation.isUsingBillingAddress,
        billing_address1: paymentInformation.paymentInputAddress,
        billing_address2: paymentInformation.paymentInputAddress2,
        billing_city: paymentInformation.paymentInputCity,
        billing_state: paymentInformation.paymentInputState,
        billing_zip: paymentInformation.paymentInputZip,
        billing_country_code: paymentInformation.paymentInputCountry.code
      },

      cc_name: paymentInformation.nameOnCard,
      cc_number: paymentInformation.creditCardNumber,
      cc_exp_date: paymentInformation.creditCardDate,
      cc_cvc: paymentInformation.cvv,
      cc_zip: shippingInformation.zipCode,
      referrer: localStorage.getItem("shapa_referrer"),
      promo_code_text: promoCode ? promoCode.promoCodeText : "",
      referral_code_text: referralCode,
      admin_referral_target_code: adminReferralTargetCode,
      is_arrival_phone_call_requested: shippingInformation.isArrivalPhoneCallRequested,

      line_items: lineItems,

      shipping_type: shippingInformation.shippingMethod.type.toUpperCase(),

      subscription_name: selectedPlan ? selectedPlan.name : null,

      // So the server can compare its calculated price to the client's.
      client_total_price: clientTotalPrice,

      // This is how we know where the user is purchasing from (ex. SHAPA, CLEARSTEP, etc).
      portal: portal,

      // Gives us an even more specific indicator of the current purchase flow than just the portal.
      purchase_flow: purchaseFlow,

      // Only applicable for clinicians that enter an NPI value (registered clinician ID).
      npi,

      // If true, it means someone is purchasing on behalf of someone else (ex. organization owner), who will be sent an email and create an account later.
      deferred_user_create: deferredUserCreate,

      gift_sender_information: giftSenderInformation
    };

    return new Promise((resolve, reject) => {
      $.ajax({
        url: "/api/v1/stripe/create_order",
        type: "POST",
        data: {
          order: order,

          // Only applicable for a flow that requires account creation.
          user: {
            first_name: shippingInformation.firstName,
            last_name: shippingInformation.lastName,
            email: shippingInformation.email,
            phone: shippingInformation.phone,
            password: shippingInformation.password,
            password_confirmation: shippingInformation.passwordConfirmation,
            organization_name: shippingInformation.organizationName,
            organization_code: shippingInformation.organizationCode
          }
        },
        success: response => resolve(camelizeKeys(response)),
        error: response => reject(response)
      });
    });
  }
}
